export default "__VITE_ASSET__be2d0499__"